import { render } from "./ItemScroll.vue?vue&type=template&id=f530b0f2"
import script from "./ItemScroll.vue?vue&type=script&lang=js"
export * from "./ItemScroll.vue?vue&type=script&lang=js"

import "./ItemScroll.vue?vue&type=style&index=0&id=f530b0f2&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__